import { solicitar } from '../identidad/cliente-identidad.js'

export type TipoObservacion = 'ASESOR' | 'INSTITUCIONAL' | 'TITULAR'
export type CategoriaObservacion = 'TRABAJO_EN_CLASE' | 'QUEJA' | 'INASISTENCIA'
export interface Observacion {
  id: string
  expedienteId: string
  tipo: TipoObservacion
  categoria: CategoriaObservacion
  fecha: string
  asunto: string
  observacion: string
  estado: 'ABIERTA' | 'CERRADA'
  autoevaluacion: string | null
  autorNombre: string
  version: number
  cantidadEvidencias: number
}
export interface EvidenciaObservacion {
  id: string
  nombreOriginal: string
  mime: string
  tamano: number
  creadoEn: string
}

export const listarObservaciones = (expedienteId: string) =>
  solicitar<{ datos: Observacion[] }>(`/api/v1/expedientes/${expedienteId}/observaciones`)
export const crearObservacion = (
  expedienteId: string,
  datos: {
    tipo: TipoObservacion
    categoria?: CategoriaObservacion
    asunto: string
    observacion: string
  },
) =>
  solicitar<{ id: string }>(`/api/v1/expedientes/${expedienteId}/observaciones`, {
    method: 'POST',
    body: JSON.stringify(datos),
  })
export const agregarEvidencia = (id: string, evidencia: File) => {
  const formulario = new FormData()
  formulario.append('evidencia', evidencia)
  return solicitar<{ estado: string }>(`/api/v1/observaciones/${id}/evidencias`, {
    method: 'POST',
    body: formulario,
  })
}
export const completarObservacion = (observacion: Observacion, autoevaluacion: string) =>
  solicitar<void>(`/api/v1/observaciones/${observacion.id}/completar`, {
    method: 'POST',
    body: JSON.stringify({ autoevaluacion, version: observacion.version }),
  })
export const listarEvidencias = (id: string) =>
  solicitar<{ datos: EvidenciaObservacion[] }>(`/api/v1/observaciones/${id}/evidencias`)
